import { Dispatch } from 'redux';
import { IDriver } from '../../../models/Driver.model';
import { Actions, GetDrivers } from './driverActions';
import { DriversConstants } from './driversConstants';
import DriverService from '../../../services/DriversService';

export function createGetDriversRequest(): GetDrivers {
  return {
    type: DriversConstants.GET_CONTRACTOR_DRIVERS_REQUEST,
  };
}

export function createGetDriversSuccess(
  payload: Array<IDriver>,
): GetDrivers.Success {
  return {
    type: DriversConstants.GET_CONTRACTOR_DRIVERS_SUCCESS,
    payload,
  };
}

export function createGetDriversFailure(error: Error): GetDrivers.Failure {
  return {
    type: DriversConstants.GET_CONTRACTOR_DRIVERS_FAILURE,
    error,
  };
}

export function getDrivers(
  contractorId: number,
  ignoreCache = false,
): (dispatch: Dispatch<Actions>) => Promise<void> {
  return async function (dispatch) {
    dispatch(createGetDriversRequest());
    try {
      const response = await DriverService.getContractorDrivers(
        contractorId,
        ignoreCache,
      );
      dispatch(createGetDriversSuccess(response));
    } catch (error) {
      console.error(error);
      dispatch(createGetDriversFailure(error));
    }
  };
}
